"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActivityStream = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Stack_1 = require("../../components/Stack");
var Row_1 = require("../../components/Row");
var classnames_1 = __importDefault(require("classnames"));
var R = __importStar(require("../../utils/ramda"));
var date_fns_tz_1 = require("date-fns-tz");
require("./ActivityStream.css");
var ActivityStreamFilterSelect_1 = require("./ActivityStreamFilterSelect");
var ActivityStreamCloseButton_1 = require("./ActivityStreamCloseButton");
var ActivityStreamCommentBox_1 = require("./ActivityStreamCommentBox");
var ActivityStreamActionMenu_1 = require("./ActivityStreamActionMenu");
var intl_1 = require("./intl");
var defaultTimestampFormat = "yyyy/MM/dd p z";
var ActivityStream = function (_a) {
  var _b, _c;
  var _d = _a.activities,
    activities = _d === void 0 ? [] : _d,
    _e = _a.timestampFormat,
    timestampFormat = _e === void 0 ? defaultTimestampFormat : _e,
    timeZone = _a.timeZone,
    timestampLocale = _a.timestampLocale,
    onClose = _a.onClose,
    _f = _a.style,
    style = _f === void 0 ? {} : _f,
    _g = _a.onCommentSubmit,
    onCommentSubmit = _g === void 0 ? R.N : _g,
    _h = _a.activityFilter,
    activityFilter = _h === void 0 ? true : _h,
    _j = _a.commentVisibilitySelection,
    commentTypeSelection = _j === void 0 ? true : _j,
    onClickVisibleToAll = _a.onClickVisibleToAll,
    onClickVisibleToInternal = _a.onClickVisibleToInternal,
    onClickVisibleToAdvertisers = _a.onClickVisibleToAdvertisers,
    _k = _a.initialCommentVisibilityState,
    initialCommentVisibilityState = _k === void 0 ? "all" : _k,
    _l = _a.commentVisibilityOptions,
    commentVisibilityOptions = _l === void 0 ? ["internal", "advertisers", "all"] : _l,
    multiFileUploadHook = _a.multiFileUploadHook,
    _m = _a.multiFileUploadProps,
    multiFileUploadProps = _m === void 0 ? {} : _m,
    commentSubmitDisabled = _a.commentSubmitDisabled,
    commentSubmitSpinner = _a.commentSubmitSpinner,
    _o = _a.setToNavHeight,
    setToNavHeight = _o === void 0 ? false : _o,
    intl = _a.intl,
    restProps = __rest(_a, ["activities", "timestampFormat", "timeZone", "timestampLocale", "onClose", "style", "onCommentSubmit", "activityFilter", "commentVisibilitySelection", "onClickVisibleToAll", "onClickVisibleToInternal", "onClickVisibleToAdvertisers", "initialCommentVisibilityState", "commentVisibilityOptions", "multiFileUploadHook", "multiFileUploadProps", "commentSubmitDisabled", "commentSubmitSpinner", "setToNavHeight", "intl"]);
  var _p = (0, react_1.useMemo)(function () {
      return (0, intl_1.createActivityStreamIntl)(intl);
    }, [intl]),
    title = _p.title,
    closeButtonTooltip = _p.closeButtonTooltip,
    commentBoxTitle = _p.commentBoxTitle,
    commentPlaceholder = _p.commentPlaceholder,
    commentSendButton = _p.commentSendButton,
    visibleToEveryone = _p.visibleToEveryone,
    visibleToInternal = _p.visibleToInternal,
    visibleToAdvertisers = _p.visibleToAdvertisers,
    filterAllActivity = _p.filterAllActivity,
    filterComments = _p.filterComments,
    attachmentTitle = _p.attachmentTitle;
  var _q = __read((0, react_1.useState)("all"), 2),
    selectedFilterId = _q[0],
    setSelectedFilterId = _q[1];
  var filters = [{
    id: "all",
    label: filterAllActivity,
    predicate: R.T
  }, {
    id: "comments",
    label: filterComments,
    predicate: function (act) {
      return act.type === "comment";
    }
  }];
  var selectedFilter = (_c = (_b = filters === null || filters === void 0 ? void 0 : filters.find(function (f) {
    return f.id === selectedFilterId;
  })) === null || _b === void 0 ? void 0 : _b.predicate) !== null && _c !== void 0 ? _c : R.T;
  var filteredData = activities.filter(selectedFilter);
  var filteredItems = filteredData.map(function (item, idx) {
    return (0, jsx_runtime_1.jsx)(ActivityStreamItem, __assign({}, item, {
      timeZone: timeZone,
      timestampFormat: timestampFormat,
      timestampLocale: timestampLocale,
      visibilityOptions: commentVisibilityOptions,
      onClickVisibleToAll: onClickVisibleToAll,
      onClickVisibleToInternal: onClickVisibleToInternal,
      onClickVisibleToAdvertisers: onClickVisibleToAdvertisers,
      visibleToTranslation: {
        internal: visibleToInternal,
        advertisers: visibleToAdvertisers,
        all: visibleToEveryone
      }
    }), idx);
  });
  var h = "calc(100vh - 60px)";
  return (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
    paddingTop: "large",
    className: "vsx-activity-stream",
    style: R.mergeRight({
      maxHeight: h,
      height: setToNavHeight ? h : undefined
    }, style)
  }, restProps, {
    children: [(0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
      justify: "space-between",
      align: "center",
      paddingLeft: "medium-large",
      paddingRight: "medium-large",
      paddingBottom: "medium-large"
    }, {
      children: [(0, jsx_runtime_1.jsx)("span", __assign({
        className: "vsx-activity-stream-title"
      }, {
        children: title
      })), (0, jsx_runtime_1.jsx)(ActivityStreamCloseButton_1.ActivityStreamCloseButton, {
        onClose: onClose,
        closeButtonTooltip: closeButtonTooltip
      })]
    })), activityFilter && (0, jsx_runtime_1.jsx)(ActivityStreamFilterSelect_1.ActivityStreamFilterSelect, {
      filters: filters,
      selectedFilterId: selectedFilterId,
      setSelectedFilterId: setSelectedFilterId
    }), (0, jsx_runtime_1.jsx)("div", {
      className: "vsx-activity-stream-divider"
    }), !!filteredData.length && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
      children: [(0, jsx_runtime_1.jsx)(Stack_1.Stack, __assign({
        gap: "2xl",
        padding: "medium-large",
        style: {
          flexGrow: 1,
          overflow: "auto"
        }
      }, {
        children: filteredItems
      })), (0, jsx_runtime_1.jsx)("div", {
        className: "vsx-activity-stream-divider"
      })]
    }), (0, jsx_runtime_1.jsx)(ActivityStreamCommentBox_1.ActivityStreamCommentBox, {
      commentSubmitSpinner: commentSubmitSpinner,
      initialVisibilityState: initialCommentVisibilityState,
      visibilitySelection: commentTypeSelection,
      visibilityOptions: commentVisibilityOptions,
      onCommentSubmit: onCommentSubmit,
      commentBoxTitle: commentBoxTitle,
      commentPlaceholder: commentPlaceholder,
      commentSendButton: commentSendButton,
      visibleToInternal: visibleToInternal,
      visibleToAdvertisers: visibleToAdvertisers,
      visibleToEveryone: visibleToEveryone,
      attachmentTitle: attachmentTitle,
      multiFileUploadHook: multiFileUploadHook,
      multiFileUploadProps: multiFileUploadProps,
      commentSubmitDisabled: commentSubmitDisabled
    })]
  }));
};
exports.ActivityStream = ActivityStream;
var ActivityStreamItem = function (_a) {
  var id = _a.id,
    heading = _a.heading,
    timestamp = _a.timestamp,
    content = _a.content,
    className = _a.className,
    timestampFormat = _a.timestampFormat,
    timestampLocale = _a.timestampLocale,
    timeZone = _a.timeZone,
    data = _a.data,
    type = _a.type,
    visibleTo = _a.visibleTo,
    visibleToTranslation = _a.visibleToTranslation,
    _b = _a.visibilityMenu,
    visibilityMenu = _b === void 0 ? false : _b,
    _c = _a.visibilityOptions,
    visibilityOptions = _c === void 0 ? ["internal", "advertisers", "all"] : _c,
    _d = _a.onClickVisibleToAll,
    onClickVisibleToAll = _d === void 0 ? R.N : _d,
    _e = _a.onClickVisibleToInternal,
    onClickVisibleToInternal = _e === void 0 ? R.N : _e,
    _f = _a.onClickVisibleToAdvertisers,
    onClickVisibleToAdvertisers = _f === void 0 ? R.N : _f,
    restProps = __rest(_a, ["id", "heading", "timestamp", "content", "className", "timestampFormat", "timestampLocale", "timeZone", "data", "type", "visibleTo", "visibleToTranslation", "visibilityMenu", "visibilityOptions", "onClickVisibleToAll", "onClickVisibleToInternal", "onClickVisibleToAdvertisers"]);
  var cn = (0, classnames_1.default)("vsx-activity-stream-item", className);
  var footnote = visibleTo ? visibleToTranslation[visibleTo] : undefined;
  var activity = {
    heading: heading,
    timestamp: timestamp,
    content: content,
    className: className,
    data: data,
    type: type,
    visibleTo: visibleTo,
    id: id
  };
  var actions = [visibilityOptions.includes("internal") ? {
    label: visibleToTranslation.internal,
    onClick: onClickVisibleToInternal
  } : null, visibilityOptions.includes("advertisers") ? {
    label: visibleToTranslation.advertisers,
    onClick: onClickVisibleToAdvertisers
  } : null, visibilityOptions.includes("all") ? {
    label: visibleToTranslation.all,
    onClick: onClickVisibleToAll
  } : null].filter(function (item) {
    return item !== null;
  });
  var formattedTime = timeZone ? (0, date_fns_tz_1.formatInTimeZone)(timestamp, timeZone, timestampFormat, {
    locale: timestampLocale
  }) : (0, date_fns_tz_1.format)(timestamp, timestampFormat, {
    locale: timestampLocale
  });
  return (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
    gap: "medium",
    className: cn
  }, restProps, {
    children: [(0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
      gap: "medium-small",
      align: "start"
    }, {
      children: [(0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
        gap: "small",
        className: "vsx-activity-stream-item-heading-row"
      }, {
        children: [(0, jsx_runtime_1.jsx)("div", __assign({
          className: "vsx-activity-stream-item-heading"
        }, {
          children: heading
        })), (0, jsx_runtime_1.jsx)("div", __assign({
          className: "vsx-activity-stream-item-timestamp"
        }, {
          children: formattedTime
        }))]
      })), visibilityMenu && (0, jsx_runtime_1.jsx)(ActivityStreamActionMenu_1.ActivityStreamActionMenu, {
        activity: activity,
        actions: actions
      })]
    })), content ? (0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-activity-stream-item-content"
    }, {
      children: content
    })) : null, footnote ? (0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-activity-stream-item-footnote"
    }, {
      children: footnote
    })) : null]
  }));
};